/* GET ROLES */
export const GET_ROLES = "GET_ROLES"
export const GET_ROLES_SUCCESS = "GET_ROLES_SUCCESS"
export const GET_ROLES_ERROR = "GET_ROLES_ERROR"

/*CREATE ROLES */
export const CREATE_NEW_ROLE = "CREATE_NEW_ROLE"
export const NEW_ROLE_SUCCESS = "NEW_ROLE_SUCCESS"
export const NEW_ROLE_ERROR = "NEW_ROLE_ERROR"

/*CREATE ROLES */
export const DUPLICATE_ROLE = "DUPLICATE_ROLE"
// reuse new_role_success and error

/*MODIFY ROLES */
export const MODIFY_ROLE = "MODIFY_ROLE"
export const MODIFY_ROLE_SUCCESS = "MODIFY_ROLE_SUCCESS"
export const MODIFY_ROLE_ERROR = "MODIFY_ROLE_ERROR"

/*DELETE ROLES */
export const DELETE_ROLE = "DELETE_ROLE"
export const DELETE_ROLE_SUCCESS = "DELETE_ROLE_SUCCESS"
export const DELETE_ROLE_ERROR = "DELETE_ROLE_ERROR"

/* ASSIGN ROLE*/
export const ASSIGN_ROLE = "ASSIGN_ROLE"
export const ASSIGN_ROLE_SUCCESS = "ASSIGN_ROLE_SUCCESS"
export const ASSIGN_ROLE_ERROR = "ASSIGN_ROLE_ERROR"

/* REMOVE ASSIGNEE*/
export const REMOVE_ASSIGNEE = "REMOVE_ASSIGNEE"
export const REMOVE_ASSIGNEE_SUCCESS = "REMOVE_ASSIGNEE_SUCCESS"
export const REMOVE_ASSIGNEE_ERROR = "REMOVE_ASSIGNEE_ERROR"

export const SET_CURRENT_ROLE_PERMISSIONS_UI_STATE = "SET_CURRENT_ROLE_PERMISSIONS_UI_STATE";
